import { calcDateYear, calcDateMonth } from "@/utils/DateHelper";

export const PERSONAL_CONFIRM_IMAGE_AT = "personal_confirm_image_at";
export const INCOME_CERTIFICATE_IMAGE_AT = "income_certificate_image_at";

export const bizTypes = [
  { name: "（選択してください）", value: "00" },
  { name: "農林水産", value: "01" },
  { name: "土木・建築・建設", value: "02" },
  { name: "製造", value: "03" },
  { name: "電気・ガス・水道", value: "04" },
  { name: "運輸", value: "05" },
  { name: "旅行", value: "06" },
  { name: "卸・商社", value: "07" },
  { name: "小売", value: "08" },
  { name: "飲食", value: "09" },
  { name: "金融・保険・証券", value: "10" },
  { name: "不動産", value: "11" },
  { name: "マスコミ・広告・印刷・出版", value: "12" },
  { name: "医療・保健衛生", value: "13" },
  { name: "教育", value: "14" },
  { name: "娯楽", value: "15" },
  { name: "公務", value: "16" },
  { name: "法律事務所", value: "17" },
  { name: "個人サービス", value: "18" },
  { name: "事業サービス", value: "19" },
  { name: "情報・通信", value: "20" },
  { name: "その他", value: "21" },
];

export const homeTypes = [
  { name: "本人持家", value: "1" },
  { name: "家族持家", value: "2" },
  { name: "公営・公団", value: "3" },
  { name: "社宅・寮", value: "4" },
  { name: "借家・<br>賃貸マンション", value: "5" },
  { name: "民間アパート", value: "6" },
  { name: "その他（間借等）", value: "7" },
];

export const residenceYears = [
  { name: "10年以上", value: calcDateYear(-10) },
  { name: "5年以上", value: calcDateYear(-7) },
  { name: "3年以上", value: calcDateYear(-4) },
  { name: "1年以上", value: calcDateYear(-2) },
  { name: "1年未満", value: calcDateMonth(-6) },
];

export const jobTypes = [
  { name: "経営者", value: "1" },
  { name: "事務・管理", value: "2" },
  { name: "販売・営業", value: "3" },
  { name: "技術・専門", value: "4" },
  { name: "労務・製造", value: "5" },
  { name: "接客・サービス", value: "6" },
  { name: "保安・清掃", value: "7" },
  { name: "その他", value: "8" },
];

export const driverLicenseFlgs = [
  { name: "あり", value: "1" },
  { name: "なし", value: "0" },
];

export const marriageStatuses = [
  { name: "あり", value: "1" },
  { name: "なし", value: "2" },
];

export const numberOfChildren = [
  { name: "なし", value: "0" },
  { name: "1人", value: "1" },
  { name: "2人", value: "2" },
  { name: "3人", value: "3" },
  { name: "4人以上", value: "4" },
];

export const sexTypes = [
  { name: "男性", value: "1" },
  { name: "女性", value: "2" },
];

export const staffNums = [
  { name: "99人以下", value: "4" },
  { name: "100～499人", value: "3" },
  { name: "500～999人", value: "2" },
  { name: "1,000人以上", value: "1" },
  { name: "不明", value: "5" },
];

export const workForms = [
  { name: "会社員・<br>団体職員", value: "01" },
  { name: "会社役員・<br>団体役員", value: "02" },
  { name: "公務員", value: "03" },
  { name: "パート・<br>アルバイト", value: "04" },
  { name: "個人事業主・<br>自営業", value: "05" },
  { name: "自由業", value: "06" },
  { name: "年金受給者", value: "07" },
  { name: "派遣・嘱託・<br>契約社員", value: "08" },
  { name: "学生（パート・アルバイト）", value: "09" },
  { name: "その他", value: "10" },
];

export const askingLoanAmounts = [
  { name: "10万円", value: "100000" },
  { name: "20万円", value: "200000" },
  { name: "30万円", value: "300000" },
  { name: "40万円", value: "400000" },
  { name: "50万円", value: "500000" },
  { name: "60万円", value: "600000" },
  { name: "70万円", value: "700000" },
  { name: "80万円", value: "800000" },
  { name: "90万円", value: "900000" },
  { name: "100万円", value: "1000000" },
];

// export const serviceExpectations = [
//   {name: '10万円', value: '01'},
//   {name: '20万円', value: '02'},
//   {name: '30万円', value: '03'},
//   {name: '40万円', value: '04'},
//   {name: '50万円', value: '05'}
// ]

export const repaymentDates = [
  // {name: '毎月12日', value: '01'},
  { name: "毎月26日", value: "26" },
];

export const identityTypes = [
  { name: "運転免許証", value: "01" },
  { name: "運転経歴証明書", value: "02" },
  { name: "パスポート", value: "03" },
  { name: "健康保険 資格確認書", value: "04" },
  { name: "マイナンバーカード", value: "05" },
];

export const subIdentityTypes = [
  { name: "住民票の写し", value: "01" },
  { name: "公的書類（※）", value: "02" },
];

export const secondIdentityTypes = [
  { name: "運転免許証", value: "01" },
  { name: "運転経歴証明書", value: "02" },
  { name: "パスポート", value: "03" },
  { name: "健康保険 資格確認書", value: "04" },
  { name: "マイナンバーカード", value: "05" },
  { name: "住民票の写し", value: "06" },
  { name: "公的書類（※）", value: "07" },
];

export const nationalityTypes = [
  { name: "はい", value: "01" },
  { name: "いいえ", value: "02" },
];

export const proofNationalityTypes = [
  { name: "在留カード", value: "03" },
  { name: "特別永住者証明書", value: "04" },
];

export const secretWordAsks = [
  { name: "選択してください", value: "00" },
  { name: "好きな花は？", value: "01" },
  { name: "好きな都市は？", value: "02" },
  { name: "好きな映画のタイトルは？", value: "03" },
  { name: "苦手な食べ物は？", value: "04" },
  { name: "初めて行った海外の都市は？", value: "05" },
  { name: "初めて飼ったペットの名前は？", value: "06" },
  { name: "初めて買った車またはバイクの名前は？", value: "07" },
  { name: "初恋の人の名前は？", value: "08" },
  { name: "卒業した小学校は？", value: "09" },
  { name: "似ている芸能人は？", value: "10" },
];

export const inputItemsMb = [
  "pincode",
  "phone_mobile",
  "postcode",
  "address_region",
  "address_city",
  "address_street",
  "address_building",
  "address_kana",
  "nky_ngt",
  "rent_loan_amount",
  "work_form",
  "biz_type",
  "job_type",
  "office_nm",
  "office_phone",
  "office_depart",
  "nsh_ngt",
  "staff_num",
  "gross_salary",
  "loan_mail",
  "loan_mail_confirmation",
  "edit_mail",
  "edit_mail_confirmation",
  "secret_word_ask",
  "secret_word_ans",
  "new_pincode",
  "new_pincode_confirmation",
  "identity",
  "subIdentity",
  "nationality",
  "proofNationality",
];

export const inputItemsCe = [
  "local_id_login",
  "local_id",
  "local_id_passwd",
  "name_kana",
  "firstname_kana",
  "birtyday",
  "secret_word_ask",
  "secret_word_ans",
  "phone",
  "phone_confirmation",
  "local_mail",
  "local_mail_confirmation",
  "local_passwd",
  "local_passwd_confirmation",
  "local_id_no_hit_user",
];

export const inputItemsEn = [
  "name_kanji",
  "name_kana",
  "bth",
  "sex",
  "phone_au_1",
  "phone_mobile",
  "loan_mail",
  "loan_mail_confirmation",
  "pincode",
  "pincode_confirmation",
  "driver_license_flg",
  "driver_license_num",
  "postcode",
  "address_region",
  "address_city",
  "address_street",
  "address_building",
  "address_kana",
  "home_type",
  "nky_ngt",
  "kyjy_ngt",
  "rent_loan_amount",
  "marriage_status",
  "number_of_children",
  "work_form",
  "biz_type",
  "job_type",
  "office_nm",
  "office_phone",
  "office_depart",
  "nsh_ngt",
  "staff_num",
  "gross_salary",
  "other_loan_count",
  "other_loan_amount",
  "asking_loan_amount",
  "repayment_date",
  "purpose_of_use",
  "secret_word_ask1",
  "secret_word_ans1",
  "secret_word_ask2",
  "secret_word_ans2",
  "secret_word_ask3",
  "secret_word_ans3",
  "confirmation_code",
];

export const inputItemsSv = ["income", "debt"];

export const apiRedirectPages = {
  1: "InternalServerError",
  9: "er003",
};

export const sctvPages = [
  {
    page: "EN001",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1001",
  },
  {
    page: "EN002",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1002",
  },
  {
    page: "EN003",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1003",
  },
  {
    page: "EN004",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1004",
  },
  {
    page: "EN005",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1005",
  },
  {
    page: "EN006",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1006",
  },
  {
    page: "TEM006",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1011",
  },
  {
    page: "EN007",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1012",
  },
  {
    page: "EN008",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1013",
  },
  {
    page: "EN009",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1014",
  },
  {
    page: "EN018",
    src: process.env.VUE_APP_FORMASSIST_TAG_EN018,
  },
  {
    page: "EN026",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=1016",
  },
  {
    page: "MB024",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2002",
  },
  {
    page: "MB027",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2003",
  },
  {
    page: "TEM017",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2004",
  },
  {
    page: "MB025",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2005",
  },
  {
    page: "MB028",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2006",
  },
  {
    page: "TEM018",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2007",
  },
  {
    page: "MB026",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2008",
  },
  {
    page: "MB029",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2009",
  },
  {
    page: "MB042",
    src: process.env.VUE_APP_FORMASSIST_TAG_MB042,
  },
  {
    page: "TEM019",
    src: "//formassist.jp/FormAssist_tag2.js?user=kddi-fs6&num=2010",
  },
];

export const affiliatePages = ["TEM001", "TEM006"];

export const dlpoPages = [
  {
    page: "EN005",
    src: "//d.adlpo.com/692/2225/js/smartadlpo.js",
    dom: '<div id="dlpoloan_moushikomiuketsukeClickCv"style="display:none;"></div>',
    script:
      'function dlpoloan_moushikomiuketsukeClickCv(){adlpoMain("loan_moushikomiuketsuke","pr=cv","img=dlpoloan_moushikomiuketsukeClickCv")}',
  },
  {
    page: "TEM002",
    src: "//d.adlpo.com/692/2225/js/smartadlpo.js",
    dom: '<div id="dlpoloan_kouzatourokuClickCv"style="display:none;"></div>',
    script:
      'function dlpoloan_kouzatourokuClickCv(){adlpoMain("loan_kouzatouroku","pr=cv","img=dlpoloan_kouzatourokuClickCv")}',
  },
  {
    page: "EN009",
    src: "//d.adlpo.com/692/2225/js/smartadlpo.js",
    dom: '<div id="dlpoloan_honninkakuninshoruiteishutsuClickCv"style="display:none;"></div>',
    script:
      'function dlpoloan_honninkakuninshoruiteishutsuClickCv(){adlpoMain("loan_honninkakuninshoruiteishutsu","pr=cv","img=dlpoloan_honninkakuninshoruiteishutsuClickCv")}',
  },
  {
    page: "EN028",
    src: "//d.adlpo.com/692/2225/js/smartadlpo.js",
    dom: '<div id="dlpoloan_sai_honninkakuninshoruiteishutsuClickCv"style="display:none;"></div>',
    script:
      'function dlpoloan_sai_honninkakuninshoruiteishutsuClickCv(){adlpoMain("loan_sai_honninkakuninshoruiteishutsu","pr=cv","img=dlpoloan_sai_honninkakuninshoruiteishutsuClickCv")}',
  },
];
